import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12,1.38C5.68,1.38.54,5.61.54,10.82A8.56,8.56,0,0,0,3.7,17.33L1.42,21.9a.5.5,0,0,0,.08.57.51.51,0,0,0,.36.15.49.49,0,0,0,.21,0L8.2,19.73a13.78,13.78,0,0,0,3.8.53c6.32,0,11.46-4.24,11.46-9.44S18.32,1.38,12,1.38Zm-5,11a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,7,12.38Zm5-3a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12,9.38Zm5,3a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,17,12.38Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }